import { ArrowRightLong } from '@baseline/ui';
import ArticleCard from '@/components/ArticleCard';
import type { TFeaturedResource } from '@/components/Header/featured.types';
import styles from './navFeatured.module.scss';

type TNavFeaturedProps = {
  resource: TFeaturedResource;
  onNavigate?: () => void;
};

const NavFeatured = ({ resource, onNavigate }: TNavFeaturedProps) => {
  return (
    <div className={styles.featured} onClick={onNavigate}>
      <span className={styles.eyebrow}>Featured</span>
      <div className={styles.cardWrap}>
        <ArticleCard
          article={resource}
          variant="navFeatured"
          metaDisplay="none"
          hideDescription
        />
        <ArrowRightLong className={styles.arrow} />
      </div>
    </div>
  );
};

export default NavFeatured;
